import { useQueryClient } from '../../lib';
import { getAuthTokensKey, getCollectionsKey, getSpaceKey, getSpacesKey, SPACES_BY_IDS_KEY, SPACES_BY_SLUGS_KEY, } from '../../utils/keys';
const findSpaceInSystemSpaces = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokensKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a, _b;
        const queryData = query[1];
        (_b = (_a = queryData === null || queryData === void 0 ? void 0 : queryData.network) === null || _a === void 0 ? void 0 : _a.systemSpaces) === null || _b === void 0 ? void 0 : _b.forEach(space => {
            var _a;
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpace = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpaceKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const space = query[1];
        if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
            (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
            ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
            cachedSpace = { ...space, ...cachedSpace };
        }
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInIds = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: SPACES_BY_IDS_KEY,
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(space => {
            var _a;
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInSlugs = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: SPACES_BY_SLUGS_KEY,
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(space => {
            var _a;
            if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
                cachedSpace = { ...space, ...cachedSpace };
            }
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInSpaces = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getSpacesKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        var _a;
        const queryData = query[1];
        (_a = queryData === null || queryData === void 0 ? void 0 : queryData.pages) === null || _a === void 0 ? void 0 : _a.forEach(page => {
            var _a;
            (_a = page === null || page === void 0 ? void 0 : page.nodes) === null || _a === void 0 ? void 0 : _a.forEach(space => {
                var _a;
                if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                    (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                    ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
                    cachedSpace = { ...space, ...cachedSpace };
                }
            });
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
const findSpaceInCollections = (args, queryClient) => {
    let cachedSpace = null;
    const queries = queryClient.getQueriesData({
        queryKey: getCollectionsKey(),
        active: true,
    });
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const queryData = query[1];
        queryData === null || queryData === void 0 ? void 0 : queryData.forEach(collection => {
            var _a, _b;
            (_b = (_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.forEach(space => {
                var _a;
                if ((space === null || space === void 0 ? void 0 : space.id) === args.id ||
                    (space === null || space === void 0 ? void 0 : space.slug) === args.slug ||
                    ((_a = space === null || space === void 0 ? void 0 : space.address) === null || _a === void 0 ? void 0 : _a.path) === args.path) {
                    cachedSpace = { ...space, ...cachedSpace };
                }
            });
        });
    });
    return cachedSpace && Object.keys(cachedSpace).length > 0
        ? cachedSpace
        : undefined;
};
export const getCachedSpace = (args, queryClient) => {
    const space = findSpaceInSystemSpaces(args, queryClient) ||
        findSpace(args, queryClient) ||
        findSpaceInIds(args, queryClient) ||
        findSpaceInSlugs(args, queryClient) ||
        findSpaceInSpaces(args, queryClient) ||
        findSpaceInCollections(args, queryClient);
    return space && Object.keys(space).length ? space : null;
};
export const useCachedSpace = (args) => {
    const queryClient = useQueryClient();
    return getCachedSpace(args, queryClient);
};
export const useCachedSpaces = (args) => {
    const queryClient = useQueryClient();
    return args
        .map(arg => getCachedSpace(arg, queryClient))
        .filter(space => space);
};
//# sourceMappingURL=useCachedSpace.js.map